import { ProjectSubmitModel } from 'api/dto/ProjectSubmit.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'projectSubmit';

export namespace ProjectSubmitState {
  export type Domain = {
    listResource?: Resource<ProjectSubmitModel[]>;
    projectId: number | null;
  };

  export const INITIAL_DOMAIN: Domain = {
    listResource: Resource.createPendingResource(),
    projectId: null,
  };
}
